export const VISITOR_CODE_LENGTH = 16;
export const VISITOR_CODE_MAX_LENGTH = 255;
export const DEFAULT_MAX_AGE = 60 * 60 * 24 * 365;
export const ZERO_MAX_AGE = 0;
export const PATH = '/';
